import { Injectable } from '@angular/core';
import { TimeService } from '@bayclubs/utils';
import moment from 'moment';
import { ICalendarDay } from '../models/calendar.model';

@Injectable({
    providedIn: 'root',
})
export class CalendarService {
    constructor(private time: TimeService) {}

    public now() {
        return this.time.nowInTimeZone(this.time.defaultTimezone());
    }

    public weekDays(): string[] {
        return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    }

    public isTheSameDay(date1: moment.Moment, date2: moment.Moment) {
        return date1.isSame(date2, 'day');
    }

    public nextMonth(date: moment.Moment) {
        return (date = this.time.addMonths(date, 1));
    }

    public proviousMonth(date: moment.Moment) {
        return (date = this.time.addMonths(date, -1));
    }

    public isInThePast(date: moment.Moment) {
        return date.isBefore(this.now(), 'day');
    }
    public isInTheFuture(date: moment.Moment) {
        return date.isAfter(this.now(), 'day');
    }

    public isToday(date: moment.Moment) {
        return this.isTheSameDay(date, this.now());
    }
    public setupDays(date: moment.Moment): ICalendarDay[] {
        let days: ICalendarDay[] = [];

        var startDay = this.time.startOfMonth(date);
        var endDay = this.time.endOfMonth(date);

        //days not in month before
        var dayWeek = startDay.day();
        while (dayWeek > 0) {
            var temp = this.time.addDays(startDay, -dayWeek);
            days.push(this.createDay(temp, false, startDay.week()));
            dayWeek--;
        }

        //days in month
        while (startDay <= endDay) {
            var week = startDay.week();

            //handle 1st week of next month
            if (date.month() == 11 && week <= 2) {
                week = 53;
            }

            days.push(this.createDay(startDay, true, week));
            startDay = this.time.addDays(startDay, 1);
        }

        //days not in month after
        var numbersOfDays = days.length;

        while (numbersOfDays % 7 !== 0) {
            endDay = this.time.addDays(endDay, 1);

            //handle 1st week of next month
            week = endDay.week();
            if (date.month() == 11 && week <= 2) {
                week = 53;
            }

            days.push(this.createDay(endDay, false, week));

            numbersOfDays = days.length;
        }

        return days;
    }

    private createDay(date: moment.Moment, isFromCurrentMonth: boolean, week: number): ICalendarDay {
        var day = <ICalendarDay>{
            date: date,
            week: week,
            isFromCurrentMonth: isFromCurrentMonth,
        };

        return day;
    }
}
